// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield20Filled: FC<CheckShield20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m9.125 12.938 4.583-4.605-1.062-1.062-3.521 3.542-1.77-1.771-1.063 1.062 2.833 2.834ZM10 18c-1.875-.458-3.427-1.52-4.656-3.188C4.114 13.146 3.5 11.3 3.5 9.271V4.5L10 2l6.5 2.5v4.77c0 2.029-.615 3.876-1.844 5.543C13.427 16.479 11.875 17.541 10 18Z" />
        </svg>
    );
};

export default CheckShield20Filled;
